<template>
  <view class="checkbox-group-round-demo">
    <view class="cube-checkbox-group-example">
      <cube-checkbox-group
        options="{{ options }}"
        wx:model="{{ checkedValues }}"
        wx:model-prop="values"
        bind:checked="onChecked"
        bind:cancelChecked="onCancelChecked"
      ></cube-checkbox-group>
    </view>
    <view class="view-desc">checked values：{{ checkedValues }}</view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    options: {
      styleIsolation: 'shared'
    },
    data: {
      options: [
        {
          value: '苹果',
          text: '苹果'
        },
        {
          value: '橘子',
          text: '橘子'
        },
        {
          value: '香蕉',
          text: '香蕉'
        },
        {
          value: '桃子',
          text: '桃子'
        }
      ],
      checkedValues: ['香蕉']
    },
    methods: {
      onChecked (e) {
        const { value } = e.detail
        console.log('选中操作：', value)
      },
      onCancelChecked (e) {
        const { value } = e.detail
        console.log('取消选中操作：', value)
      }
    }
  })
</script>

<style lang="stylus">
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

<script type="application/json">
{
  "styleIsolation": "shared",
  "usingComponents": {
    "cube-checkbox-group": "@mpxjs/mpx-cube-ui/src/components/checkbox-group/index.mpx",
    "cube-checkbox": "@mpxjs/mpx-cube-ui/src/components/checkbox/index.mpx"
  }
}
</script>
